module.exports = __webpack_public_path__ + "img/vessel-dark-circle.9bd44c60.svg";